import { useEffect } from 'react';

export default function Alert(props) {

  function selectAlert() {
    if(props.onSelect) props.onSelect(props.name);
  }

  function clickAlert() {
    if(props.onMove) props.onMove(props.name);
    return false;
  }

  function leaveAlert() {
    if(props.onSelect) props.onSelect("");
  }

  function openSite() {
    if(props.onOpenSite) props.onOpenSite({menu:"site",site:props.name});
  }

  useEffect(() => {
    const target = document.getElementById("btn_"+props.name);
    target.oncontextmenu = function () {
      clickAlert();
      return false;
    };
  },[props.name]);

  function luminance(rgba) {
    var r = 0.298912;
    var g = 0.586611;
    var b = 0.114478;
    return Math.floor(r * rgba[0] + g * rgba[1] + b * rgba[2]);
  }

  return (
    <div id={props.name} title={props.name}>
      <button id={"btn_"+props.name} onMouseEnter={selectAlert} onMouseLeave={leaveAlert} onClick={openSite} style={{backgroundColor: props.color, color: props.fontcolor, marginTop:"1px", display: "flex", justifyContent: "space-between"}}>
        <span style={{whiteSpace: "nowrap", overflow: "hidden"}}>{props.name}</span>
        <span style={{whiteSpace: "nowrap", textIndent: "0.25em"}}>{props.value==null?"欠測":props.value+props.unit}</span>
      </button>
    </div>
  )
}